import React from "react";
import VersionLabel from "../versionLabel";
import css from "./index.m.css";
export default (props) => {
  const { isRequired, versionTitle, children } = props;
  return (
    <div className={css['version-option']}>
      <VersionLabel isRequired={isRequired} versionTitle={versionTitle} />
      {children}
    </div>
  );
};
